import { capitalize } from "lodash-es";
const __script_base__ = {
  name: 'WCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    css: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: 'default'
    },
    isClickable: {
      type: Boolean,
      default: false
    },
    isCompact: {
      type: Boolean,
      default: false
    },
    withBorder: {
      type: Boolean,
      default: false
    },
    withBorderRadius: {
      type: Boolean,
      default: false
    },
    withBoxShadow: {
      type: Boolean,
      default: false
    },
    withCoverImage: {
      type: Boolean,
      default: false
    },
    withFooter: {
      type: Boolean,
      default: false
    },
    coverImage: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      isDesignMode: this.$attrs['data-uc-design-mode'],
      usingFallbackCover: false,
      fallbackCover: 'https://vfiles.gtimg.cn/vupload/20210305/4876411614948521407.jpg'
    };
  },
  watch: {
    coverImage() {
      this.usingFallbackCover = false;
    }
  },
  computed: {
    extraClasses() {
      return `${['isClickable', 'isCompact', 'withFooter', 'withBorder', 'withBorderRadius', 'withBoxShadow', 'withCoverImage'].filter(key => this[key]).join(' ')}
      with${capitalize(this.background)}Background`;
    }
  },
  methods: {
    handleCardClick(ev) {
      // footer 区不需要发出 click 事件
      const {
        footer
      } = this.$refs;
      if (footer && (ev.target === footer || footer.contains(ev.target))) return;
      this.$emit('click', this);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "w-card",
    class: _vm.extraClasses + " " + _vm.className,
    style: _vm.css,
    attrs: {
      tabindex: _vm.isClickable ? "0" : "-1"
    },
    on: {
      click: _vm.handleCardClick,
      mouseenter: function ($event) {
        return _vm.$emit("mouseenter", this);
      },
      mouseleave: function ($event) {
        return _vm.$emit("mouseleave", this);
      }
    }
  }, [_vm.withCoverImage ? _c("div", {
    staticClass: "w-card-coverImageWrapper",
    on: {
      click: function ($event) {
        return _vm.$emit("clickHeader", this);
      }
    }
  }, [_c("img", {
    staticClass: "w-card-coverImage",
    attrs: {
      src: _vm.usingFallbackCover ? _vm.fallbackCover : _vm.coverImage
    },
    on: {
      error: function () {
        _vm.usingFallbackCover = true;
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm.title || _vm.$slots.action ? _c("div", {
    staticClass: "w-card-header",
    on: {
      click: function ($event) {
        return _vm.$emit("clickHeader", this);
      }
    }
  }, [_c("div", {
    staticClass: "w-card-title",
    attrs: {
      title: _vm.title
    },
    on: {
      click: function ($event) {
        return _vm.$emit("click", this);
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c("div", {
    ref: "actions",
    staticClass: "w-card-actions uc-slotForBlocks"
  }, [_vm._t("action")], 2)]) : _vm._e(), _vm._v(" "), _c("div", {
    ref: "content",
    staticClass: "w-card-content uc-slotForBlocks",
    class: {
      isEmpty: !this.$slots.default
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.withFooter ? _c("div", {
    ref: "footer",
    staticClass: "w-card-footer uc-slotForBlocks",
    class: {
      isEmpty: !this.$slots.footer
    }
  }, [_vm._t("footer", function () {
    return [_vm.isDesignMode ? _c("div", {
      staticClass: "w-card-footerEmptyPlaceholder"
    }, [_vm._v("\n        在这里可放置组件\n      ")]) : _vm._e()];
  })], 2) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Card/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);